<template>
  <div
    id="custom_intercom_button"
    class="intercomButtonMainWrapper"
    :class="{ higher: HIGHER }"
    @click="open = !open"
  >
    <div v-if="notif_count" class="notifPill">
      <span class="notifValue">{{ notif_count }}</span>
    </div>
    <div class="customButton">
      <i class="far fa-comment-alt" :class="{ open }" />
      <i class="fas fa-times" :class="{ open }" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"

export default {
  data: function () {
    return {
      open: false,
      notif_count: 0,
    }
  },
  mounted: function () {
    if (typeof Intercom !== "undefined") {
      Intercom("onUnreadCountChange", function (count) {
        if (count) this.notif_count = count
      })
    }
  },
  computed: {
    ...mapState({
      HIGHER: (state) => state.misc.intercom.higher,
    }),
  },
}
</script>

<style scoped>
.intercomButtonMainWrapper {
  cursor: pointer;
  position: fixed;
  z-index: 10000;
  bottom: 24px;
  left: 24px;
  height: 60px;
  width: 60px;
  transition: 0.2s var(--trans-standart);
}

.intercomButtonMainWrapper.higher {
  bottom: 96px;
  transition: 0.2s var(--trans-standart);
}

.notifPill {
  height: 22px;
  width: 22px;
  border-radius: 50%;
  box-shadow: var(--shadow-regular-dark);
  background-color: var(--color-error);
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  margin-left: 44px;
  margin-bottom: 44px;
}

.notifValue {
  color: var(--color-white);
  font-weight: 600;
  font-size: var(--font-size-small);
}

.customButton {
  height: 60px;
  width: 60px;
  border-radius: 50%;
  background-color: var(--color-main);
  box-shadow: var(--shadow-regular-dark);
  display: flex;
  justify-content: center;
  align-items: center;
}

.fa-comment-alt {
  position: absolute;
  margin-top: 3px;
  font-size: var(--font-size-title-big);
  color: var(--color-white);
  transition: 0.2s var(--trans-standart);
  opacity: 1;
}
.fa-comment-alt.open {
  transition: 0.1s var(--trans-standart);
  opacity: 0;
}
.fa-times {
  position: absolute;
  margin-top: 2px;
  font-size: var(--font-size-title);
  color: var(--color-white);
  transition: 0.1s var(--trans-standart);
  transform: rotate(-45deg) translate(0px);
  opacity: 0;
}
.fa-times.open {
  transition: 0.2s var(--trans-standart);
  transform: rotate(0deg) translate(0px);
  opacity: 1;
}

@media screen and (max-width: 767px) {
  .fa-comment-alt {
    font-size: var(--font-size-title);
  }

  .fa-times {
    font-size: var(--font-size-title-small);
  }

  .notifValue {
    font-size: var(--font-size-eleven);
  }
}
</style>
